export enum ListOrderType {
  None,
  Now,
  Future,
  Any,
  Locked = 4,
}
